"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniquePlayerIds = exports.getPlayersIdsFromEvent = exports.getParametersFromBasketOutcome = exports.getParametersFromEvent = exports.getParametersFromBetsHistory = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const uniq_1 = __importDefault(require("lodash/uniq"));
/**
 * @deprecated use getPlayerIdsForBetsHistory from domain/players/utils
 */
const getParametersFromBetsHistory = (data) => data.items.flatMap((item) => item.outcomes.map((outcome) => outcome.parameters));
exports.getParametersFromBetsHistory = getParametersFromBetsHistory;
/**
 * @deprecated use getPlayerIdsForEvent from domain/players/utils
 */
const getParametersFromEvent = (probabilities) => probabilities.markets.flatMap((market) => market.probabilities.map((prob) => prob.parameters));
exports.getParametersFromEvent = getParametersFromEvent;
/**
 * @deprecated use getPlayerIdsForBasket from domain/players/utils
 */
const getParametersFromBasketOutcome = (data) => data.flatMap((outcome) => [outcome.probability.parameters]);
exports.getParametersFromBasketOutcome = getParametersFromBasketOutcome;
/**
 * @deprecated use domain/players/utils
 */
const getPlayersIdsFromEvent = (event) => {
    if (event === undefined) {
        return [];
    }
    return (0, exports.getUniquePlayerIds)(event.probabilities, exports.getParametersFromEvent);
};
exports.getPlayersIdsFromEvent = getPlayersIdsFromEvent;
/**
 * @deprecated use functions from domain/players/utils
 */
const getUniquePlayerIds = (probabilities, getParameters) => {
    if (!probabilities) {
        return [];
    }
    const parameters = getParameters(probabilities);
    const playerIds = parameters
        .flat()
        .filter((param) => param.type === betweb_openapi_axios_1.ParameterType.PlayerId)
        .map((param) => Number(param.value));
    return (0, uniq_1.default)(playerIds);
};
exports.getUniquePlayerIds = getUniquePlayerIds;
//# sourceMappingURL=index.js.map